import { onUnmounted } from 'vue'

export const useDelayedAction = (delay: number) => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null

  const cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = null
    }
  }

  const schedule = (callback: () => void) => {
    cancel()
    timeoutId = setTimeout(callback, delay)
  }

  const scheduleIfNotCancelled = (callback: () => void) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    timeoutId = setTimeout(callback, delay)
  }

  onUnmounted(() => {
    cancel()
  })

  return {
    schedule,
    cancel,
    scheduleIfNotCancelled,
  }
}
